import { timeSinceShort } from 'utils/formatDatetime'

export const getStopUpdatedInfo = stop => {
  const showScheduleByWebIcon =
    !stop.confirmedByName &&
    !stop.appointmentTimeUpdatedByName &&
    stop.schedulingOption === 'web_or_tms'
  const updatedByName = !stop.confirmedByName && stop.appointmentTimeUpdatedByName
  const managerTagTooltip = `Appt time edited by ${updatedByName} ${timeSinceShort(
    stop.appointmentTimeUpdatedAt
  )}`
  return { showScheduleByWebIcon, updatedByName, managerTagTooltip }
}

export const getApptUpdatedConfirmedInfo = (appointment, schedulingOption) => {
  const { appointmentTimeUpdatedAt, appointmentTimeUpdatedByName, confirmedByName } = appointment
  const updatedOrConfirmedName = confirmedByName || appointmentTimeUpdatedByName
  const updatedOrConfirmedMessage = confirmedByName
    ? `Confirmed by ${updatedOrConfirmedName}`
    : `Appt time edited by ${updatedOrConfirmedName} ${timeSinceShort(appointmentTimeUpdatedAt)}`
  const showScheduleByWebLink = !confirmedByName && schedulingOption === 'web_or_tms'
  return { showScheduleByWebLink, updatedOrConfirmedName, updatedOrConfirmedMessage }
}
